export const KYC_HISTORY = "kyc-history";
